class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
            (this.debouncedOnSubmit = debounce((e) => {
console.log('test 11');
                this.onSubmitHandler(e);
            }, 500));
        let e = this.querySelector("form");
        e.addEventListener("input", this.debouncedOnSubmit.bind(this));
        let t = this.querySelector("#FacetsWrapperDesktop");
        t && t.addEventListener("keyup", onKeyUpEscape);
    }
    static setListeners() {
        let e = (e) => {
            let t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
            t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1);
        };
        window.addEventListener("popstate", e);
    }
    static toggleActiveFacets(e = !0) {
        document.querySelectorAll(".js-facet-remove").forEach((t) => {
            t.classList.toggle("disabled", e);
        });
    }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    let a = FacetFiltersForm.getSections(),
        i = document.getElementById("ProductCount"),
        s = document.getElementById("ProductCountDesktop");
    
    const productGridContainer = document.getElementById("ProductGridContainer");
    if (productGridContainer) {
        const collection = productGridContainer.querySelector(".collection");
        if (collection) {
            collection.classList.add("loading");
        }
    }
    
    i && i.classList.add("loading");
    s && s.classList.add("loading");
    
    a.forEach((r) => {
        let a = `${window.location.pathname}?section_id=${r.section}&${e}`;
        // Remove the caching logic and always fetch fresh data
        FacetFiltersForm.renderSectionFromFetch(a, t);
    });
    
    r && FacetFiltersForm.updateURLHash(e);
}
    static renderSectionFromFetch(e, t) {
        fetch(e)
            .then((e) => e.text())
            .then((r) => {
                let a = r;
console.log("renderSectionFromFetch");
console.log(a);
                (FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: a, url: e }]),
                    FacetFiltersForm.renderFilters(a, t),
                    FacetFiltersForm.renderProductGridContainer(a),
                  console.log("test renderProductCount"+a);
                   FacetFiltersForm.renderProductCount(a),
                    "undefined" != typeof globoswatch && globoswatch.init();
            });
    }
   static renderProductGridContainer(e) {
    const container = document.getElementById("ProductGridContainer");
    const parsedHtml = new DOMParser().parseFromString(e, "text/html");
    const parsedContainer = parsedHtml.getElementById("ProductGridContainer");
    
    if (container && parsedContainer) {
        container.innerHTML = parsedContainer.innerHTML;
        
        // Then run the mobile-list-grid code that follows
        // Get the .mobile-list-grid element
        var mobileListGrid = document.querySelector('.mobile-list-grid');
        
        // Check if .mobile-list-grid is found
        if (mobileListGrid) {
            // Check if it has children with class 'active'
            var hasActiveChildren = mobileListGrid.querySelector('.active');
            
            // Check if .active child element is found
            if (hasActiveChildren) {
                // Check if .active child element is clickable
                if (typeof hasActiveChildren.click === 'function') {
                    // Trigger a click event
                    hasActiveChildren.click();
                } else {
                    console.error('.active child element cannot be clicked.');
                }
            } else {
                console.error('.active child element not found within .mobile-list-grid.');
            }
        } else {
            console.error('.mobile-list-grid element not found.');
        }
    } else {
        console.error("ProductGridContainer not found in either the document or the parsed HTML");
    }
  }
    static renderProductCount(e) {
        // let t = new DOMParser().parseFromString(e, "text/html").getElementById("ProductCountDesktop").innerHTML,
        //     r = document.getElementById("ProductCount"),
        //     a = document.getElementById("ProductCountDesktop");
        // (r.innerHTML = t), r.classList.remove("loading"), a && ((a.innerHTML = t), a.classList.remove("loading"));

       try {
        const parsedDoc = new DOMParser().parseFromString(e, "text/html");
        const parsedCountDesktop = parsedDoc.getElementById("ProductCountDesktop");
  console.log('129');
console.log(parsedDoc);
console.log(parsedCountDesktop);
        
        if (!parsedCountDesktop) {
            console.log("ProductCountDesktop not found in parsed HTML");
            return;
        }
        
        const t = parsedCountDesktop.innerHTML;
        const r = document.getElementById("ProductCount");
        const a = document.getElementById("ProductCountDesktop");
        
        if (r) {
            r.innerHTML = t;
            r.classList.remove("loading");
        } else {
            console.log("ProductCount element not found in document");
        }
        
        if (a) {
        
            a.innerHTML = t;
            a.classList.remove("loading");
        } else {
            console.log("ProductCountDesktop element not found in document");
        }
    } catch (error) {
        console.error("Error in renderProductCount:", error);
    }

      
    //   document.querySelectorAll("form#FacetFiltersFormMobile .mobile-facets__main.has-submenu.gradient details").forEach((detail) => {
    //  // console.log(detail)
    //   let summarySpan = detail.querySelector("summary span");
    //   if (summarySpan && summarySpan.textContent.trim() === "Availability") {
    //     detail.style.display = "none"; // Hide only "Availability" filters
    //   }
    // })

  
 
      // Find the span with the exact text "Availability: In stock"
      const activeFacetsContainer = document.querySelector('facet-filters-form .active-facets.active-facets-desktop ');
      
      const availabilitySpan = Array.from(activeFacetsContainer.querySelectorAll('span.active-facets__button-inner'))
      .find(span => span.childNodes[0].textContent.trim() === 'Availability: In stock');
      
      if (availabilitySpan) {
      const parentAnchor = availabilitySpan.closest('a');
      if (parentAnchor) {
        parentAnchor.style.display = 'none';
      }
      }

        // sstart
    const seenFilters = new Map();
    // Get all details elements and process them in order
    const allDetails = document.querySelectorAll("form#FacetFiltersFormMobile .mobile-facets__main details");
    
    allDetails.forEach((detail) => {
        // Skip elements that are already hidden
        if (detail.style.display === "none") return;
        
        const summarySpan = detail.querySelector("summary span");
        if (!summarySpan) return;
        
         const filterName = summarySpan.textContent.trim();
        const detailId = detail.getAttribute("id");
 const dataIndex = detail.getAttribute("data-index"); 
      
    
      const hasRequiredClasses = detail.classList.contains("mobile-facets__details") &&
                                   detail.classList.contains("js-filter") &&
                                   detail.classList.contains("menu-opening");
        

       if (!detailId) return; // Skip if no ID is present

        if (filterName === "Availability") {
            detail.style.display = "none"; // Always hide "Availability" filter
            console.log(`Hiding Availability filter: ${detailId}`);
            return;
        }
        
        // If we've seen this filter name before, hide this element
        if (seenFilters[filterName]) {
          console.log(detail);
          console.log(seenFilters[filterName]);
           const SeendataIndex = detail.getAttribute("data-index"); 
          const existingDetail = seenFilters.get(filterName);
        console.log(SeendataIndex);
            // Compare based on classes and data-index
            if (!hasRequiredClasses &&  SeendataIndex) {
                document.getElementById(detailId).style.display = "none";
                console.log(`Hiding duplicate: ${filterName} (ID: ${detailId}, data-index: ${dataIndex})`);
            } else {
                // Hide the previous one and store the new one instead
                //document.getElementById(existingDetail.id).style.display = "none";
                seenFilters.set(filterName, { id: detailId, dataIndex, hasRequiredClasses });
                console.log(`Replacing with: ${filterName} (ID: ${detailId}, data-index: ${dataIndex})`);
            }
         

        } else {
            // First time seeing this filter, mark it as seen
            seenFilters[filterName] = true;
            console.log(`Unique filter found: ${filterName}`);
        }
    });
      // e--nd
    }
    static renderFilters(e, t) {
      //old
   //      let r = new DOMParser().parseFromString(e, "text/html"),
   //          a = r.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),
   //          i = (e) => {
   //              let r = t ? t.target.closest(".js-filter") : void 0;
   //              return !!r && e.dataset.index === r.dataset.index;
   //          },
   //          s = Array.from(a).filter((e) => !i(e)),
   //          l = Array.from(a).find(i);
   //     console.log('renderFilters');
   //    console.log(l);
   //      s.forEach((e) => {
   // console.log(e.innerHTML);
   //          document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML;
   //      }),
   //          FacetFiltersForm.renderActiveFacets(r),
   //          FacetFiltersForm.renderAdditionalElements(r),
   //          l && FacetFiltersForm.renderCounts(l, t.target.closest(".js-filter"));

        let r = new DOMParser().parseFromString(e, "text/html"),
          a = r.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),
          i = (e) => {
              let r = t ? t.target.closest(".js-filter") : void 0;
              return !!r && e.dataset.index === r.dataset.index;
          },
          s = Array.from(a).filter((e) => !i(e)),
          l = Array.from(a).find(i);
          
      // Update filters that aren't being clicked
      s.forEach((e) => {
          const targetFilter = document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`);
          if (targetFilter) {
              targetFilter.innerHTML = e.innerHTML;
          }
      });

  console.log("renderFilters 239");
      console.log(r);

      // Handle active facets rendering separately to avoid duplications
      FacetFiltersForm.renderActiveFacets(r);
      FacetFiltersForm.renderAdditionalElements(r);
      
      // Only update counts for the clicked filter if it exists
      if (l && t && t.target) {
          const clickedFilter = t.target.closest(".js-filter");
          if (clickedFilter) {
              FacetFiltersForm.renderCounts(l, clickedFilter);
          }
      }
    }
    static renderActiveFacets(e) {
        // [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
        //     let r = e.querySelector(t);
        //     r && (document.querySelector(t).innerHTML = r.innerHTML);
        // }),
        //     FacetFiltersForm.toggleActiveFacets(!1);
console.log(e);
                [".active-facets-mobile", ".active-facets-desktop"].forEach((selector) => {
            const sourceElement = e.querySelector(selector);
            const targetElement = document.querySelector(selector);
            
            if (sourceElement && targetElement) {
                // Clear existing contents first
                targetElement.innerHTML = '';
                
                // Get all unique filter buttons from the source
                const sourceButtons = sourceElement.querySelectorAll('.active-facets__button');
                const addedFilters = new Set();
                
                // Add each unique filter button to the target
                sourceButtons.forEach(button => {
                    // Get a unique identifier for this filter (text content or data attribute)
                    const filterText = button.querySelector('.active-facets__button-inner')?.textContent.trim() || 
                                      button.textContent.trim();
                    
                    // Only add if we haven't added this filter already
                    if (!addedFilters.has(filterText)) {
                        // Clone the button to avoid reference issues
                        const clonedButton = button.cloneNode(true);
                        targetElement.appendChild(clonedButton);
                        addedFilters.add(filterText);
                    }
                });
            }
        });
        
        // Re-enable filter removal functionality
        FacetFiltersForm.toggleActiveFacets(false);
        
        // Re-attach event listeners to the new filter buttons
        document.querySelectorAll(".active-facets__button").forEach(button => {
console.log(button);
            button.addEventListener('click', function(event) {
                // Find the closest facet-remove element and trigger its closeFilter method
                const facetRemove = this.closest('facet-remove');
                if (facetRemove && typeof facetRemove.closeFilter === 'function') {
                    facetRemove.closeFilter(event);
                }
            });
        })
    }
    static renderAdditionalElements(e) {

       console.log('renderAdditionalElements');
   console.log(e);
        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
            e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
        }),
            document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
/*
        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
        const sourceElement = e.querySelector(t);
        const targetElement = document.querySelector(t);

          console.log(sourceElement);
              console.log(targetElement);
          
        // if (sourceElement && targetElement) {
        //     targetElement.innerHTML = sourceElement.innerHTML;
        //     console.log(`Updated ${t} with new content`);
        // } else if (!sourceElement) {
        //     console.error(`Source element ${t} not found in parsed HTML`);
        // } else if (!targetElement) {
        //     console.error(`Target element ${t} not found in document`);
        // }
    });
    
   
      const menuDrawer = document.getElementById("FacetFiltersFormMobile").closest("menu-drawer");
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
          menuDrawer.bindEvents();
      } else {
          console.error("Menu drawer not found or bindEvents is not a function");
      }
      */
    }
    static renderCounts(e, t) {
        let r = t.querySelector(".facets__selected"),
            a = e.querySelector(".facets__selected"),
            i = t.querySelector(".facets__summary"),
            s = e.querySelector(".facets__summary");
        a && r && (t.querySelector(".facets__selected").outerHTML = e.querySelector(".facets__selected").outerHTML), i && s && (t.querySelector(".facets__summary").outerHTML = e.querySelector(".facets__summary").outerHTML);
    }
   static updateURLHash(e) {
    // Remove filter.v.availability=1 from the URL
    let urlParams = e.replace(/&?filter\.v\.availability=1/g, '');
    history.pushState({ searchParams: e }, "", `${window.location.pathname}${urlParams && "?".concat(urlParams)}`);
}
    static getSections() {
        return [{ section: document.getElementById("product-grid").dataset.id }];
    }
    createSearchParams(e) {
        let t = new FormData(e);
        return new URLSearchParams(t).toString();
    }
    onSubmitForm(e, t) {
        FacetFiltersForm.renderPage(e, t);
    }
   onSubmitHandler(e) {
    e.preventDefault();
    let t = document.querySelectorAll("facet-filters-form form");
    if ("mobile-facets__checkbox" == e.srcElement.className) {
        let r = this.createSearchParams(e.target.closest("form"));
        // Ensure filter.v.availability=1 is included
        if (!r.includes('filter.v.availability=1')) {
            r += '&filter.v.availability=1';
        }
        this.onSubmitForm(r, e);
    } else {
        let a = [],
            i = "FacetFiltersFormMobile" === e.target.closest("form").id;
        t.forEach((e) => {
            if (i) {
                if ("FacetFiltersFormMobile" === e.id) {
                    let params = this.createSearchParams(e);
                    // Ensure filter.v.availability=1 is included
                    if (!params.includes('filter.v.availability=1')) {
                        params += '&filter.v.availability=1';
                    }
                    a.push(params);
                }
            } else if ("FacetSortForm" === e.id || "FacetFiltersForm" === e.id || "FacetSortDrawerForm" === e.id) {
                let t = document.querySelectorAll(".no-js-list");
                t.forEach((e) => e.remove());
                let params = this.createSearchParams(e);
                // Ensure filter.v.availability=1 is included
                if (!params.includes('filter.v.availability=1')) {
                    params += '&filter.v.availability=1';
                }
                a.push(params);
            }
        }),
        this.onSubmitForm(a.join("&"), e);
    }
  }
    onActiveFilterClick(e) {
        e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
        let t = -1 == e.currentTarget.href.indexOf("?") ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(t);
    }
}
(FacetFiltersForm.filterData = []),
    (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
    (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
    customElements.define("facet-filters-form", FacetFiltersForm),
    FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
    constructor() {
        super(), this.querySelectorAll("input").forEach((e) => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues();
    }
    onRangeChange(e) {
        this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
    }
    setMinAndMaxValues() {
        let e = this.querySelectorAll("input"),
            t = e[0],
            r = e[1];
        r.value && t.setAttribute("max", r.value), t.value && r.setAttribute("min", t.value), "" === t.value && r.setAttribute("min", 0), "" === r.value && t.setAttribute("max", r.getAttribute("max"));
    }
    adjustToValidValues(e) {
        let t = Number(e.value),
            r = Number(e.getAttribute("min")),
            a = Number(e.getAttribute("max"));
        t < r && (e.value = r), t > a && (e.value = a);
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector("a");
        e.setAttribute("role", "button"),
            e.addEventListener("click", this.closeFilter.bind(this)),
            e.addEventListener("keyup", (e) => {
                e.preventDefault(), "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
            });
    }
    closeFilter(e) {
        e.preventDefault();
        let t = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
        t.onActiveFilterClick(e);
    }
}
customElements.define("facet-remove", FacetRemove);




function hideAvailabilityFilter() {
 
  const activeFacetsContainer = document.querySelector('.active-facets.active-facets-desktop');
  

  if (!activeFacetsContainer) return;


  const availabilitySpan = Array.from(activeFacetsContainer.querySelectorAll('span.active-facets__button-inner'))
    .find(span => span.childNodes[0].textContent.trim() === 'Availability: In stock');
  

  if (availabilitySpan) {
    const parentAnchor = availabilitySpan.closest('a');
    if (parentAnchor) {
      parentAnchor.style.display = 'none';
    }
  }

      document.querySelectorAll("form#FacetFiltersFormMobile .mobile-facets__main.has-submenu.gradient details").forEach((detail) => {
     // console.log(detail)
      let summarySpan = detail.querySelector("summary span");
      if (summarySpan && summarySpan.textContent.trim() === "Availability") {
        detail.style.display = "none"; // Hide only "Availability" filters
      }
    })

  
}


document.addEventListener('DOMContentLoaded', hideAvailabilityFilter);
